import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: ${({ position }) =>
    position === 'column' ? 'row' : 'column'};

  width: 100%;

  @media (max-width: 425px) {
    flex-direction: column;
  }
`;

export const GroupButtons = styled.div`
  ${({ position }) =>
    position === 'column'
      ? css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          padding: 1rem;

          button:not(:first-child) {
            margin-top: 1rem;
          }

          @media (max-width: 425px) {
            flex-direction: row;

            button:not(:first-child) {
              margin-left: 1rem;
              margin-top: 0;
            }
          }
        `
      : css`
          display: flex;
          align-items: center;
          justify-content: flex-end;

          button {
            margin-left: 1.5rem;
          }

          @media (max-width: 375px) {
            flex-direction: column;

            button {
              margin-left: 0;
            }
          }
        `};

  button {
    max-width: fit-content;
  }
`;
